<template>
  <div>
      <loading v-if="showLoading"></loading>
      <Breadcrumb v-bind:data="BreadcrumbList"></Breadcrumb>

         <div class="widget has-shadow">

             <div class="widget-header bordered d-flex align-items-center">
                 <h2>افزودن پیام جدید</h2>
             </div>

             <div class="widget-body">


               <div v-if="errors.length>0" class="alert alert-warning">
                   <ul class="errors_ul">
                      <li :key="key" v-for="(error,key) in errors">{{ error[0] }}</li>
                   </ul>
               </div>
               <div class="form-group">
                    <label>عنوان پیام : </label>
                    <input type="text" class="form-control total_width_input" v-model="title">
                    <span v-if="title_error" class="has_error"> {{ title_error }}</span>
                </div>
                <div class="form-group">
                    <textarea class="textArea" v-model="content" placeholder="پیام شما"></textarea>
                    <p v-if="content_error" style="padding-right:0px" class="has_error"> {{ content_error }}</p>
                </div>

                <div class="form-group">
                    <label>انتخاب فایل : </label>
                    <input type="file" ref="fileInput" v-on:change="selectFile" style="direction:ltr">
                </div>

                <div class="form-group">
                     <button class="btn btn-success" v-on:click="addMessage()">ارسال پیام</button>
                </div>

             </div>

        </div>
      <server-error-message v-if="server_error"></server-error-message>  
  </div>
</template>

<script>
import Breadcrumb from './Breadcrumb';
import myMinix from '../myMixin';
import Loading from './Loading';
import ServerErrorMessage from './ServerErrorMessage'
export default {
   components:{Breadcrumb,Loading,ServerErrorMessage},
   mixins:[myMinix],
    data(){
        return{
            server_error:false,
            BreadcrumbList:[
                { path:'/messages',title:'مدیریت پیام ها' },
                 {path:'/messages/add',title:'افزودن پیام جدید'}
            ],
            showLoading:false,
            title:'',
            content:'',
            image:'',
            errors:[],
            send_form:true,
            title_error:false,
            content_error:false
        }
    },
    mounted(){
        this.$emit('setSideBarItem','messages');
    },
    methods:{
        selectFile:function(){
            this.image=this.$refs.fileInput.files[0];
        },
        addMessage:function(){
            if(this.send_form){
                const check_title=this.validate_field('عنوان پیام',this.title,'title_error');
                const check_content=this.validate_field('محتوای پیام',this.content,'content_error');
                if(check_title && check_content){
                    this.errors=[]
                    this.showLoading=true;
                    this.send_form=false;
                    const url=this.$siteUrl+'/api/seller/message/add';
                    const formData=new FormData();
                    formData.append('title',this.title);
                    formData.append('content',this.content);
                    if(this.image!=""){
                      formData.append('pic',this.image);
                    }
                    this.axios.post(url,formData,this.setHeader(true)).then(response=>{
                        this.showLoading=false;
                        this.send_form=true;
                        const result=this.setAccountStatus(response.data);
                        if(result)
                        {
                            if(response.data.status=="error")
                            { 
                                const errors=response.data.errors;
                                const keys=Object.keys(errors);
                                for(var i=0;i<keys.length;i++)
                                {
                                    this.errors.push(errors[keys[i]]);
                                }
                            }
                            else if(response.data.status=="ok")
                            {
                                this.$router.push({name:'MessageList',params:{success:'ok'}})
                            }
                            else{
                                this.show_server_error();
                            }
                        }
                    }).catch((error) => {
                        this.send_form=true;
                        this.setCatch(error);
                    });
                }
            }
        }
    }
}
</script>

<style>

</style>